import { TreeNode } from 'types/interfaces';

import { DepartmentsService, EmployeesService } from 'components/services';

export const getEmployeeCallback = async (
  employeeId: number | undefined,
  departments: TreeNode[] | undefined,
  setValue: (field: string, value: any) => void,
  setSelectedDistricts: (districts: TreeNode[]) => void,
  setNewUser: (value: boolean) => void
) => {
  if (employeeId) {
    const result = await EmployeesService.getEmployeeById(employeeId);
    const data = result.data;

    if (!data) return;

    const departmentIds = data?.departmentIds ?? [];
    if (departmentIds.length > 0 && departments) {
      const selectedDistricts = departmentIds.flatMap((x) =>
        departments.flatMap((d) => findDepartments(d, x.toString()) ?? [])
      );
      setSelectedDistricts(selectedDistricts);
    }

    setValue('surname', data?.surname ?? '');
    setValue('name', data?.name ?? '');
    setValue('middleName', data?.middleName ?? '');
    setValue('personnelNumber', data?.personnelNumber ?? '');
    setValue('department', data?.department);
    setValue('phone', data?.phone ?? '');
    setValue('email', data?.email ?? '');
    setValue('isUser', data?.isUser ?? false);
    setValue('login', data?.login ?? '');
    setValue('isTwoFactorEnabled', data?.isTwoFactorEnabled ?? false);
    setValue('userRole', data?.userRole ?? []);
    setValue('inheritedRoles', data?.inheritedRoles ?? []);
    setValue('rolesDepartments', data?.rolesDepartments ?? []);

    setNewUser(!data?.login);
  }
};

export const getDepartmentsCallback = async (
  setDepartments: (departments: TreeNode[]) => void
) => {
  const result = await DepartmentsService.getDepartments({
    all: true,
    withSelectAll: true
  });
  const departments = result.data ?? [];
  setDepartments(departments);
  return departments;
};

// Helper for finding departments recursively
export const findDepartments = (
  department: TreeNode,
  key: string
): TreeNode[] => {
  if (department.key === key) return [department];
  if (department.children)
    return department.children.flatMap((d) => findDepartments(d, key) ?? []);
  return [];
};
